import React from "react";
import { FormSectionElements, ProgramContainer } from "../../entities/formTemplateDataType";
import PasswordHide from './../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-password-hide.svg'
import { getRootComponent } from "../../utilities/ElementUtils";
interface Props {
    field: FormSectionElements;
    callback: (programContainer: ProgramContainer) => void
}

export default class PasswordHideButtonCompnent extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

    }

    render() {
        const field = this.props.field;
        return <button type="button" aria-pressed="true" aria-label="Hide field" aria-live="polite" style={{ border: 'none', backgroundColor: 'transparent', padding: 0, cursor: 'pointer' }} onClick={() => { field.mask = true; this.props.callback(getRootComponent(field)) }}>
            <img
                src={PasswordHide}
                alt="Field is visible"
                style={{
                    cursor: 'pointer',
                    height: '24px',
                    width: '24px'
                }}>
            </img>
        </button>
    }
}